import { lazy, Suspense, useState } from 'react';
import { Navigate } from 'react-router-dom';
import ReportButtonPortal from '../components/feature/ReportButtonPortal';

const HomePage = lazy(() => import('./home/page'));
const WorkReportAuthPage = lazy(() => import('./work-report-auth/page'));

export default function HomeRouter() {
  const [showReportAuth, setShowReportAuth] = useState(false);

  const hash = window.location.hash;
  const searchParams = new URLSearchParams(window.location.search);
  const hashToken = hash.startsWith('#token=') ? hash.slice(7) : null;
  const isAuthHash = hash === '#auth';
  const hasToken = !!hashToken || searchParams.has('token');

  // 리포트 인증 화면
  if (hasToken || showReportAuth || isAuthHash) {
    return (
      <Suspense fallback={
        <div style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #ecfdf5, #fff, #f0fdfa)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{ color: '#10b981', fontSize: '15px', fontWeight: 600 }}>
            리포트 불러오는 중...
          </div>
        </div>
      }>
        <WorkReportAuthPage />
      </Suspense>
    );
  }

  const isDesktopForced = searchParams.has('view') && searchParams.get('view') === 'desktop';
  const ua = navigator.userAgent || '';
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  const isNarrow = window.innerWidth <= 767;
  const isMobile = (isMobileUA || isNarrow) && !isDesktopForced;

  // 모바일: /mobile 로 즉시 리다이렉트 (App.tsx MobileRedirector와 이중 안전장치)
  if (isMobile) {
    return <Navigate to="/mobile" replace />;
  }

  // PC 전용
  return (
    <>
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#0d1f3c' }} />}>
        <HomePage />
      </Suspense>
      <ReportButtonPortal onClick={() => setShowReportAuth(true)} />
    </>
  );
}
